import { useTranslation } from "react-i18next";
import Field from "../../../../../../components/Field";
import Checkbox from "../../../../../../components/Inputs/Checkbox";
import { useConfig } from "./config";

const toCamelCase = (value) => {
    return value.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
};

function Content({ option }) {
    const { t } = useTranslation();
    const name = toCamelCase(option);
    const config = useConfig(name);

    return (
        <div className="mb-5">
            <h3 className="w-100 px-3 mb-2 font-weight-bold text-dark">
                {t(option)}
            </h3>

            <div className="px-3">
                {config.map((item, index) => (
                    <div
                        key={item.key + index}
                        className="m-0 p-0 d-flex justify-content-between align-items-center"
                    >
                        <div>
                            {item.name}
                        </div>

                        <div className="px-3 py-1">
                            <Field
                                name={[name, item.key]}
                                valuePropName="checked"
                                className="m-0 p-0"
                            >
                                <Checkbox
                                    id={name + item.key + index}
                                    labelClassName="px-2"
                                />
                            </Field>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Content;
